import React from 'react';
import { BsFileEarmarkPdfFill } from "react-icons/bs";

interface PolicyPdfIconProps {
  className?: string;
}

const PolicyPdfIcon: React.FC<PolicyPdfIconProps> = ({ className = "w-5 h-5", ...props }) => {
  const PdfIcon = BsFileEarmarkPdfFill as any;

  return (
    <PdfIcon color="#E53935" {...props} />
  );
};

export default PolicyPdfIcon;

